import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled, useTheme } from "@mui/material/styles";
import { MobileStepper, Button, Box } from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const Root = styled("div")({
  maxWidth: "100%",
  flexGrow: 1,
});

const Img = styled("img")({
  display: "block",
  width: "100%",
  borderRadius: 16,
  objectFit: "cover",
});

const SwipeableTextMobileStepper = ({ bannerData }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const maxSteps = bannerData.length;

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleStepChange = (step) => setActiveStep(step);

  if (!bannerData || bannerData.length === 0) return null;

  return (
    <Root>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={3000}
      >
        {bannerData.map((step, index) => (
          <Box key={index} sx={{ px: 0.5 }}>
            {Math.abs(activeStep - index) <= 2 && (
              <Img src={step.bannerUrl} alt={step.label} />
            )}
          </Box>
        ))}
      </AutoPlaySwipeableViews>

      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{ background: "transparent" }}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            sx={{ visibility: "hidden" }}
          >
            Next
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button
            size="small"
            onClick={handleBack}
            disabled={activeStep === 0}
            sx={{ visibility: "hidden" }}
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Root>
  );
};

SwipeableTextMobileStepper.propTypes = {
  bannerData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      bannerUrl: PropTypes.string,
    })
  ),
};

export default SwipeableTextMobileStepper;